const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M13 6v12l8.5-6M4 18l8.5-6L4 6v12Z\"/>"
};
exports.__esModule = true;
exports.default = data;
